import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'error';

export interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  className?: string;
}

const toneClass: Record<BadgeTone, string> = {
  neutral: 'ui-badge--neutral',
  accent: 'ui-badge--accent',
  success: 'ui-badge--success',
  warning: 'ui-badge--warning',
  error: 'ui-badge--error',
};

export function Badge({ children, tone = 'neutral', className = '' }: BadgeProps) {
  return (
    <span className={`ui-badge ${toneClass[tone]} ${className}`.trim()}>{children}</span>
  );
}
